import { render, staticRenderFns } from "./OfferedVisits.vue?vue&type=template&id=a61c7710&scoped=true"
import script from "./OfferedVisits.vue?vue&type=script&lang=ts"
export * from "./OfferedVisits.vue?vue&type=script&lang=ts"
import style0 from "./OfferedVisits.vue?vue&type=style&index=0&id=a61c7710&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c7710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61c7710')) {
      api.createRecord('a61c7710', component.options)
    } else {
      api.reload('a61c7710', component.options)
    }
    module.hot.accept("./OfferedVisits.vue?vue&type=template&id=a61c7710&scoped=true", function () {
      api.rerender('a61c7710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/Visits/EmptyVisits/OfferedVisits.vue"
export default component.exports